import script from "./faqListTab.vue?vue&type=script&setup=true&name=faqListTab&lang=js"
export * from "./faqListTab.vue?vue&type=script&setup=true&name=faqListTab&lang=js"

const __exports__ = script;

export default __exports__